<template>
  <v-card elevation="4" max-width="340" min-width="340"  class=" ma-1">
    <v-img class="rounded-b-0 RoundedImages" max-height="200" min-height="200" :src="img">
      <v-card style="top: 15%" width="70%" color="#D6AF44" dark elevation="0" class="rounded-l-0 pa-2 rounded-r-pill font-weight-bold">
        {{ title }}
      </v-card>
    </v-img>
    <!-- <v-card-title class="playFairFontPC pb-0 pt-2">
      {{ title }}
    </v-card-title> -->
    <v-card-text class="text-start pb-0">
      {{ text }}
    </v-card-text>
    <v-card-actions class="pb-2 pt-0">
      <v-row justify="end" no-gutters>
<!--        <v-btn text class="font-weight-black">See More</v-btn>-->
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ParkCard",
  props:{
    title:String,
    text:String,
    img:String,
  }
}
</script>

<style scoped>
.playFairFontPC{
  font-family: 'Playfair Display',serif !important;
  color: #1A4F57;
  font-weight: bolder;
}

.RoundedImages{
  border-bottom-right-radius: 42px !important
}
</style>
